import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { Node, ReactFlowInstance } from 'reactflow'

interface UseJourneyDeepLinkParams {
    flowInstance: ReactFlowInstance | null
    nodes: Node[]
    setNodes: (updater: (nodes: Node[]) => Node[]) => void
}

export function useJourneyDeepLink({
    flowInstance,
    nodes,
    setNodes,
}: UseJourneyDeepLinkParams) {
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const nodeId = searchParams.get('node')
        const stepId = searchParams.get('step')

        if (!flowInstance || nodes.length === 0 || (!nodeId && !stepId)) return

        let targetNode: Node | undefined

        if (nodeId) {
            targetNode = nodes.find(n => n.id === nodeId)
        } else if (stepId) {
            targetNode = nodes.find(n => n.data.stepId === Number(stepId))
        }

        if (targetNode) {
            const x = targetNode.position.x + ((targetNode.width ?? 120) / 2)
            const y = targetNode.position.y + ((targetNode.height ?? 120) / 2)
            flowInstance.setCenter(x, y, { zoom: 1 })

            setNodes(nds => nds.map(n => ({
                ...n,
                selected: n.id === targetNode!.id,
            })))

            searchParams.delete('node')
            searchParams.delete('step')
            setSearchParams(searchParams, { replace: true })
        }
    }, [flowInstance, nodes, searchParams, setSearchParams, setNodes])
}
